import { useQuery } from 'urql';
import { SearchResultPageBackChannelRequestDebugDataDocument } from '@packages/gql/generated/shopping/SearchResultPageBackChannelRequestDebugDataDocument';

import { BackChannelRequestCodeBlocks } from './BackChannelRequestCodeBlocks';

/* GraphQL */ `
  query SearchResultPageBackChannelRequestDebugData(
    $params: SearchParametersInput!
    $query: String!
  ) {
    search(params: $params, query: $query) {
      ...BackChannelRequestCodeBlocksFragment
    }
  }
`;

export const SearchResultPageBackChannelRequestDebugInfo = <
  Variables extends Record<string, unknown>,
>({
  variables,
}: {
  variables: Variables;
}) => {
  const [{ data }] = useQuery({
    query: SearchResultPageBackChannelRequestDebugDataDocument,
    variables: variables as any, // typing everything generically is a pain in the ass, this is just a debug panel
    requestPolicy: 'network-only', // for unknown reasons related to the graphcache, the query does not perform a network request unless the fragment contents are inlined into the query as well, or the requestPolicy is set to network-only
  });

  if (!data) return null;

  return <BackChannelRequestCodeBlocks maskedResult={data.search} />;
};
